import React from 'react';
import ReactDOM from 'react-dom';
import './theme.css';
import ps01 from "./images/ps01.png"
import ps02 from "./images/pso2.png"
import ps03 from "./images/ps03.png"
import ps04 from "./images/ps04.png"
import ps05 from "./images/ps05.png"

function ThemeType(props) {
    return (
        <div className="HackathonTheme">

            <div class="wrapper">

                <div class="cards_wrap">
                    <div class="card_item">
                        <div class="card_inner">
                            <img src={ps01} alt="ps01" style={{height:200,width:250}}/><br/><br/>
                            <div class="role_name">Student Skills</div>
                            
                            <div class="film">Recommendations for improvement of students’ skills. </div>
                        </div>
                    </div>
                    <div class="card_item">
                        <div class="card_inner">
                            <img src={ps02} alt="ps02" style={{height:200,width:250}} /><br/><br/>
                            <div class="role_name">Open Innovation</div>
                            
                            <div class="film"> Solution for the proper management of hostels.</div>
                        </div>
                    </div>
                    <div class="card_item">
                        <div class="card_inner">
                            <img src={ps03} alt="ps03" style={{height:200,width:250}} /><br/><br/>
                            <div class="role_name">University Map  tracking</div>
                            
                           <div class="film">Design an interactive map of the university, including indoor maps  etc. </div>
                        </div>
                    </div>
            
                    <div class="card_item">
                        <div class="card_inner">
                            <img src={ps04} alt="ps04" style={{height:200,width:250}}/><br/><br/>
                            <div class="role_name">Education</div>
                            
                           <div class="film">Alumni Tracking System for College. </div>
                        </div>
                    </div>
                    <div class="card_item">
                        <div class="card_inner">
                            <img src= {ps05} alt="ps05" style={{height:200,width:250}}/><br/><br/>
                            <div class="role_name">Training and Placement</div>
                            
                            <div class="film">Interlinking of Campus placement </div>
                        </div>
                    </div>
                    <div class="card_item">
                        {/* <div class="card_inner">
                            <img src="./images/ai1.jpg" /><br/><br/>
                            <div class="role_name">AI/ML</div>
                            
                            <div class="film">AI is the intelligence demonstrated by computers as a result of their perception of their surroundings. Al-based devices are capable of taking independent actions in order to achieve a specific goal.</div>
                        </div> */}
                    </div>
                </div>
            </div>

            <button> <a target="_blank"href="https://drive.google.com/file/d/1_YardwSV6tJYswFKBXVNWWpLtuMPAYyK/view?usp=sharing" rel="noreferrer" style={{color:"white"}} >Know More</a></button>
        </div>
    );
}

export default ThemeType;